export const SMART_TIME_PROPERTY_NAME = 'EntityExtraction/Events1.0';
export const SMART_TIME_PROPERTY_NAME_NEW = 'EntityExtraction/CalendarRelated1.0';
export const SMART_TIME_DISTINGUISHED_PROPERTY_SET_ID = 'Common';
export const SMART_TIME_PROPERTY_TYPE = 'String';
